import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { Handset, WhatsApp } from '@sgcmpteltd/uikit-react';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { joinSgcmMedia, joinSgcmSite } from '@/utils/url/join/public';
import { getPhoneUrl } from '@/utils/url/phone';

import {
  PARALLEL_IMPORTERS,
  PROMOTION_COVER_HEIGHT,
  PROMOTION_COVER_WIDTH,
  PROMOTION_DEALER_INFO_ICON_SIZE,
  WHATSAPP_ICON_SIZE,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PiPromoContent: Component = ({ item, index, onItemClick }) => {
  const promoImageUrl = item?.dealer?.type === PARALLEL_IMPORTERS
    ? item.image
    : joinSgcmMedia(`/public/new-cars/promos/${item?.dealer.id}/tactical-ads-${item?.id}-d-700x394.jpg`);

  const imageUrl = promoImageUrl instanceof URL
    ? promoImageUrl.toString()
    : promoImageUrl;

  const [whatsAppLink, setWhatAppLink] = useState('');

  const whatsAppMessage = 'Hi, I\'m interested!';
  const encodedUrl = encodeURIComponent(whatsAppMessage);

  useEffect(() => {
    if (item?.dealer.type === 'ad') {
      if (item.dealer.contactNumbers
        && item.dealer.contactNumbers.length >= 2) {
        setWhatAppLink(`https://api.whatsapp.com/send?phone=65${item.dealer.contactNumbers[1]}&text=${encodeURIComponent(item.link)}%0A%0A${encodedUrl}`);
      } else {
        setWhatAppLink('');
      }
    } else {
      setWhatAppLink(`https://api.whatsapp.com/send?phone=65${item?.dealer.whatsAppNumber}&text=${encodeURIComponent(item?.link || '')}%0A%0A${encodedUrl}`);
    }
  }, [item, encodedUrl]);

  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();

  return (
    <div className={styles.containerRoot}>
      <figure
        className={styles.containerPromotionCarCover}>
        <button onClick={() => {
          onItemClick?.(index);
        }}>
          <Image
            alt={`${item?.title}`}
            className={styles.imagePromotionCarCover}
            height={PROMOTION_COVER_HEIGHT}
            src={imageUrl}
            width={PROMOTION_COVER_WIDTH} />
        </button>
      </figure>
      <div className={styles.containerText}>
        <Link
          className={styles.textDealerName}
          href={`${joinSgcmSite(`/new_cars/newcars_promotionslist.php?DID=${item?.dealer.id}`)}`}>
          {item?.dealer.name}
        </Link>
        <div className={styles.textSummery}>
          {item?.summary}
        </div>
        <button
          className={styles.textFindOutMore}
          onClick={() => {
            onItemClick?.(index);
          }}>
          Find out more
        </button>
      </div>
      { whatsAppLink !== ''
        ? (
          <div
            className={styles.containerWhatsAppButton}>
            <a
              href={whatsAppLink}
              rel="noreferrer noopener"
              target="_blank">
              <button
                className={styles.buttonWhatsApp}>
                <WhatsApp
                  size={WHATSAPP_ICON_SIZE} />
                WhatsApp
              </button>
            </a>
          </div>
        )
        : null}
      <div className={styles.containerContact}>
        <div className={styles.containerPhoneNumber}>
          <div
            className={styles.containerDealerInfoIcon}>
            <Handset
              size={PROMOTION_DEALER_INFO_ICON_SIZE} />
          </div>
          { item?.dealer.whatsAppNumber
            ? (
              <ul
                className={styles.listDealerPhoneNumber}>
                <li
                  key={item?.dealer.whatsAppNumber}
                  className={styles.containerDealerPhoneNumber}>
                  {isDesktopMode
                    ? (
                      <span
                        className={styles.textDesktopNumber}>
                        {`${item?.dealer.whatsAppNumber.slice(0, 4)} ${item?.dealer.whatsAppNumber.slice(4)}`}
                      </span>
                    )
                    : (
                      <Link
                        className={styles.textDealerPhoneNumber}
                        href={`${getPhoneUrl(item?.dealer.whatsAppNumber)}`}>
                        {`${item?.dealer.whatsAppNumber.slice(0, 4)} ${item?.dealer.whatsAppNumber.slice(4)}`}
                      </Link>
                    )}
                </li>
              </ul>
            )
            : (
              <ul
                className={styles.listDealerPhoneNumber}>
                {
                  item?.dealer.contactNumbers.map(phoneNumber => (
                    <li
                      key={phoneNumber}
                      className={styles.containerDealerPhoneNumber}>
                      { isDesktopMode
                        ? (
                          <span
                            className={styles.textDesktopNumber}>
                            {`${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4)}`}
                          </span>
                        )
                        : (
                          <Link
                            className={styles.textDealerPhoneNumber}
                            href={`${getPhoneUrl(phoneNumber)}`}>
                            {`${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4)}`}
                          </Link>
                        )}
                    </li>
                  ))
                }
              </ul>
            )}

        </div>
      </div>
    </div>
  );
};
